import { FC, Fragment, useState } from "react";
import { Avatar, Box, Typography } from "@mui/material";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";
import { SideModalProps } from "DataTypes/Modal";
import { PatientInitialStateType, UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import PatientFormatter from "Utils/Patient.Formatter";
import DateTime from "Utils/DateTime";
import EditProfile from "./EditProfile";

const ProfileModal: FC<SideModalProps> = (props) => {
  const { onClose } = props;
  const { patientInfo, patientOrg }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { streetAddress, address2, city, state, zip, country } = patientInfo;
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const fullAddress =
    (streetAddress ? `${streetAddress}, ` : "") +
    (address2 ? `${address2}, ` : "") +
    (city ? `${city}, ` : "") +
    (state ? `${state} ` : "") +
    (zip ? `${zip}` : "") +
    ((state || zip) && country ? ", " : "") +
    (country ? country : "");
  const [showLayer2, setShowLayer2] = useState(false);
  const crudPermission = myInfo.roleId != 6;

  const handleCloseLayer2: () => void = () => {
    setShowLayer2(false)
  };

  const ProfileData = [
    {
      id: "name",
      label: patientInfo.name + ` (${patientInfo.age}, ${patientInfo.gender})`,
      icon: ImgPath.PersonIcon
    },
    {
      id: "dob",
      label: DateTime.ToLocalDate(patientInfo.dob),
      icon: ImgPath.CalendarIcon
    },
    {
      id: "lang",
      label: patientInfo.language,
      icon: ImgPath.LanguageIcon
    },
    {
      id: "add1",
      label: fullAddress,
      icon: ImgPath.LocationIcon
    },
    {
      id: "homeno.",
      label: PatientFormatter.MobileNumber(patientInfo.home),
      icon: ImgPath.CallIcon
    },
    {
      id: "mobno.",
      label: PatientFormatter.MobileNumber(patientInfo.mobile),
      icon: ImgPath.SmartphoneIcon
    },
    {
      id: "mail",
      label: patientInfo.email,
      icon: ImgPath.EmailIcon
    }
  ];

  const OrgData = [
    {
      id: "org-name",
      label: patientOrg.practiceName,
      icon: ImgPath.OrganisationIcon
    },
    {
      id: "loc-name",
      label: patientOrg.practiceLocationName,
      icon: ImgPath.LocationIcon
    },
    {
      id: "timezone",
      label: patientOrg.practiceLocationTimezone,
      icon: ImgPath.AddTimeLogIcon
    },
  ]

  const ProfileUI = (
    <Fragment>
      <Box width={80} height={80} sx={{ ...CommonStyle.sxRowCenter }}>
        <Avatar src={""} alt="" sx={{ height: "100%", width: "100%" }} />
      </Box>
      {ProfileData.map(el => {
        return (
          <Box key={el.id}>
            <el.icon color="secondary" fontSize="small" sx={{ mr: 1 }} />
            <Typography variant={el.id == "name" ? "body2" : "subtitle1"}>
              {el.label}
            </Typography>
          </Box>
        )
      })}
    </Fragment>
  );

  const OrgUI = (
    <Fragment>
      <Typography variant="body2" sx={{ ...sxOrghead }}>
        Organization Details
      </Typography>
      {OrgData.map(el => {
        return (
          <Box key={el.id}>
            <el.icon color="secondary" fontSize="small" />
            <Typography variant="subtitle1" sx={{ ml: 1 }}>
              {el.label}
            </Typography>
          </Box>
        )
      })}
    </Fragment>
  );

  const Layer1 = (
    <Fragment>
      <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
        <Typography fontWeight="bold">Profile</Typography>
        <Box display={"flex"}>
          {
            crudPermission && (
              <Box
                sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
                onClick={() => setShowLayer2(true)}
              >
                <ImgPath.EditOutlined titleAccess="Edit Profile" />
              </Box>
            )
          }
          <Box
            sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
            onClick={() => {
              handleCloseLayer2();
              onClose();
            }}
          >
            <ImgPath.CloseIcon titleAccess="Close" />
          </Box>
        </Box>
      </Box>
      <Box sx={{ ...sxMain, "& >div": { ...CommonStyle.sxRow, mb: 1 } }}>
        {ProfileUI}
        {OrgUI}
      </Box>
    </Fragment>
  );

  return (
    <Fragment>
      <Box width="25%">{Layer1}</Box>
      <Box width="1%"></Box>
      {showLayer2 && <Box width="74%"><EditProfile onClose={onClose} /></Box>}
    </Fragment>
  );
};
export default ProfileModal;

const sxHeader = {
  justifyContent: "space-between",
  height: "8%",
  px: 2,
};

const sxMain = {
  height: "90%",
  overflow: "auto",
  px: 2,
};

const sxOrghead = {
  borderTop: "1px solid",
  borderColor: "custom.main",
  pt: 1,
  my: 1,
  fontWeight: "bold"
}
